import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { useState } from 'react';

import type { BookingDetailAnchor } from '../../../../../Legacy/Types';
import styles from '../../BookingDetails.module.scss';

enum BookingMenuItemKey {
  Booking = 'booking',
  PaymentDetails = 'payment-details',
  VirtualCard = 'virtual-card',
  Help = 'help',
}

type BookingHeaderProps = {
  isIssuingBooking: boolean;
};

export const BookingHeader = ({ isIssuingBooking }: BookingHeaderProps) => {
  const vccItems = [
    { label: 'Virtual Card', key: BookingMenuItemKey.VirtualCard },
    { label: 'Help', key: BookingMenuItemKey.Help },
  ];

  const items = [
    { label: 'Booking', key: BookingMenuItemKey.Booking },
    { label: 'Payment details', key: BookingMenuItemKey.PaymentDetails },
    ...(isIssuingBooking ? vccItems : []),
  ];

  const [currentAnchor, setCurrentAnchor] = useState<BookingDetailAnchor>(
    BookingMenuItemKey.Booking
  );

  const onClick: MenuProps['onClick'] = (e) => {
    const element = document.getElementById(e.key);

    setCurrentAnchor(e.key as BookingDetailAnchor);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Menu
      onClick={onClick}
      mode="horizontal"
      items={items}
      selectedKeys={[currentAnchor]}
      className={styles.bookingHeaderMenu}
    />
  );
};
